import React from 'react'
import ScriptInfoEditor from './ScriptInfoEditor'
import ScriptCodeEditor from './ScriptCodeEditor'

function createInfoEditor( script, props ) {
  return <ScriptInfoEditor script={script} {...props} />
}

function createCodeEditor( script, props ) {
  return <ScriptCodeEditor script={script} {...props} />
}

exports.createInfoEditor = createInfoEditor
exports.createCodeEditor = createCodeEditor
